import { useLanguage } from '@base/LanguageProvider';
import { ListItemTable } from '@features/list-item-table/ListItemTable';
import IntervalToolbar from '@main/flow/IntervalToolbar';
import { ModelContent } from '@styled/Model';
import React from 'react';
import { useAuth } from '../../providers/AuthProvider';
import { XTable } from './table';
export default function TableChart(_a) {
    var toolbarWrapHeight = _a.toolbarWrapHeight, modelTableData = _a.modelTableData, hasCustomCols = _a.hasCustomCols;
    var L = useLanguage().L;
    var userSettings = useAuth().settings;
    var finderExpanded = userSettings.finder_expanded;
    var getTableAndListItemsHeight = function (finderExpanded, toolbarWrapHeight) {
        var freeSpace = window.innerHeight - 164; // navbar = 44; finderToolbar = 40; space = 20; footerInterval = 60;
        return freeSpace - toolbarWrapHeight - (finderExpanded ? 250 : 0);
    };
    var tableHeight = getTableAndListItemsHeight(finderExpanded, toolbarWrapHeight);
    return (React.createElement(React.Fragment, null,
        React.createElement(ModelContent, null, userSettings.list_items_show ? (React.createElement(ListItemTable, { height: tableHeight, format: userSettings.number_format_type, invalidate: modelTableData.invalidate })) : hasCustomCols || !!userSettings.model_table_periods.length ? (React.createElement(XTable, { modelTableData: modelTableData, tableKey: "ModelTable", containerHeight: tableHeight, numberFormatType: userSettings.number_format_type })) : (React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: tableHeight,
                width: '100%',
            } },
            React.createElement("h4", null, L('Please choose a time period'))))),
        React.createElement(IntervalToolbar, null)));
}
